export const RATING_BABYSITTER_REMOVE_REQUEST = 'rating/babysitter-remove-request'
export const RATING_BABYSITTER_REMOVE_SUCCESS = 'rating/babysitter-remove-success'
export const RATING_BABYSITTER_REMOVE_FAILED = 'rating/babysitter-remove-failed'
